<template>
<div class="chapter">
<div class="inner_page">
<h1>Kiss of Gold</h1>
<h3 class="sigil_not_in_toc">Samantha Harte</h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_title.vue?45a4656a